import { render, staticRenderFns } from "./ChatInputMobile.vue?vue&type=template&id=bb7f1862&"
import script from "./ChatInputMobile.vue?vue&type=script&lang=js&"
export * from "./ChatInputMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports